import { DynamicObjectInterface } from '../../../sdk/type';
import { DetailCardProgress } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';

export const getTeamListConfig: GetColumnsType = () => [
  {
    key: '',
    width: 20,
    sortable: true,
    render: (object: DynamicObjectInterface) => {
      return <DetailCardProgress {...(object as DynamicObjectInterface)} isTeamList={true} showFiveProgress={false} />;
    },
  },
];
